import { render, staticRenderFns } from "./HousePriceComputed.vue?vue&type=template&id=647d4337&scoped=true&"
import script from "./HousePriceComputed.vue?vue&type=script&lang=js&"
export * from "./HousePriceComputed.vue?vue&type=script&lang=js&"
import style0 from "./HousePriceComputed.vue?vue&type=style&index=0&id=647d4337&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647d4337",
  null
  
)

export default component.exports